export function CopyToClipboardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10 3a3 3 0 00-3 3v1a3 3 0 00-3 3 1 1 0 102 0 1 1 0 011-1h1a1 1 0 001-1V6a1 1 0 011-1h6c.553 0 1 .447 1 .999v8.958a.189.189 0 01-.05.048l-.006.003.01-.003A.199.199 0 0117 15v1.2c0 .442.373.811.775.627.242-.11.452-.265.62-.432.328-.328.605-.82.605-1.395V5.999A2.999 2.999 0 0016 3h-6z"
      ></path>
      <path
        fill="currentColor"
        d="M12 7a1 1 0 100 2h1a1 1 0 011 1 1 1 0 102 0 3 3 0 00-3-3h-1zM6 13.5a1 1 0 10-2 0v1a1 1 0 102 0v-1zM16 13.5a1 1 0 10-2 0v1a1 1 0 102 0v-1zM7 19a1 1 0 01-1-1 1 1 0 10-2 0 3 3 0 003 3h1a1 1 0 100-2H7zM14 18a1 1 0 01-1 1h-1a1 1 0 100 2h1a3 3 0 003-3 1 1 0 10-2 0z"
      ></path>
    </svg>
  );
}
